import React from "react";
import { Link } from "react-router-dom";

const StoryCard = ({ heading, from, description, img, click }) => {
  return (
    <Link
      to={`${
        from === "podcast"
          ? "/video-craft-show/episode"
          : "/category/case-studies/details"
      } `}
    >
      <div
        onClick={click}
        className="max-w-[305px] cursor-pointer m-1 my-3 md:my-6  hover:shadow-[0_4px_35px_-17px_rgba(0,0,0,0.3)] shadow-[0_2px_15px_-17px_rgba(0,0,0,0.3)] transition-all duration-300 ease-out"
      >
        <img
          src={require("../images/" + img)}
          alt=""
          className="w-[100%] h-48"
        />
        <div className="px-2 py-4">
          <h1 className="text-[19px] font-semibold max-w-[98%] line-clamp-3">
            {heading}
          </h1>
          <h1 className="text-[17px] text-gray-500  mt-2 max-w-[98%] line-clamp-3">
            {description}
          </h1>
          <div className="mt-5 mb-2 text-center lg:text-left">
            <button className="px-5 py-2 text-lg font-semibold text-gray-500 transition duration-200 ease-out bg-gray-200 md:text-xl hover:bg-gray-300">
              Read more
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default StoryCard;
